export function getApartmentImage(input) {
  // ------------------------------
  // CASE 1: apartment object
  // ------------------------------
  if (typeof input === "object" && input !== null) {
    // Prefer API images if available
    if (typeof input.image === "string") return input.image;

    if (Array.isArray(input.images) && input.images.length > 0) {
      const first = input.images[0];
      return typeof first === "string" ? first : first?.url;
    }

    // Fallback to name-based images
    if (typeof input.name === "string") {
      return getApartmentImage(input.name);
    }

    return "/assets/images/placeholder.jpg";
  }

  // ------------------------------
  // CASE 2: name string
  // ------------------------------
  if (typeof input === "string") {
    const folder = input
      .replace(/apartment/i, "")
      .replace(/\s+/g, "")
      .toLowerCase();

    const candidates = [
      `/assets/images/${folder}/A-1.jpg`,
      `/assets/images/${folder}/1.jpeg`,
      `/assets/images/${folder}/1.png`,
      `/assets/images/${folder}/1.webp`,
      `/assets/images/${folder}/1.jpg`,
    ];

    // ✅ Return FIRST image only
    return candidates[0];
  }

  // ------------------------------
  // FINAL FALLBACK
  // ------------------------------
  return "/assets/images/placeholder.jpg";
}
